// author:Renuka
import {
  lightgreenCardHeader,
  brownCardHeader,
  pinkCardHeader,
  neonCardHeader,
  lightorangeCardHeader,
  warningCardHeader,
  orangeCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  greenCardHeader,
  cyanCardHeader,
  primaryCardHeader,
  roseCardHeader,
  whiteColor,
  singlegreenCardHeader,
  darkgreenCardHeader,
  lightblueCardHeader,
  navyblueCardHeader,
  multiplegreenCardHeader,
  deviceCardHeader,
  redvoiletCardHeader,
  licenseCardHeader,
} from "./material-dashboard-react";

const cardHeaderStyle = {
  cardHeader: {
    padding: "0.75rem 1.25rem",
    marginBottom: "0",
    borderBottom: "none",
    background: "transparent",
    zIndex: "3 !important",
    "&$cardHeaderPlain,&$cardHeaderIcon,&$cardHeaderStats,&$warningCardHeader,&$orangeCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$cyanCardHeader,&$greenCardHeader,&$primaryCardHeader,&$roseCardHeader,&$lightgreenCardHeader,&$brownCardHeader,&$pinkCardHeader,&$neonCardHeader,&$lightorangeCardHeader,&$singlegreenCardHeader,&$multiplegreenCardHeader,&$deviceCardHeader,&$redvoiletCardHeader,&$darkgreenCardHeader,&$lightblueCardHeader,&$navyblueCardHeader,&$licenseCardHeader":
      {
        margin: "0 15px",
        padding: "0",
        position: "relative",
        color: whiteColor,
      },
    "&:first-child": {
      borderRadius: "calc(.25rem - 1px) calc(.25rem - 1px) 0 0",
    },
    "&$warningCardHeader,&$orangeCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,greenCardHeader,&$cyanCardHeader,&$primaryCardHeader,&$roseCardHeader,&$lightgreenCardHeader,&$brownCardHeader,&$lightorangeCardHeader,&$singlegreenCardHeader,&$multiplegreenCardHeader,&$deviceCardHeader,&$redvoiletCardHeader,&$darkgreenCardHeader,&$lightblueCardHeader,&$navyblueCardHeader,&$licenseCardHeader":
      {
        "&:not($cardHeaderIcon)": {
          borderRadius: "3px",
          marginTop: "-20px",
          padding: "15px",
        },
      },
    "&$cardHeaderStats svg": {
      // header icon css:
      fontSize: "36px",
      lineHeight: "56px",
      textAlign: "center",
      // width,height css for box:
      width: "25px",
      height: "25px",
      margin: "10px 10px 4px",
    },
    "&$cardHeaderStats i,&$cardHeaderStats .material-icons": {
      fontSize: "36px",
      lineHeight: "56px",
      width: "56px",
      height: "56px",
      textAlign: "center",
      overflow: "unset",
      marginBottom: "1px",
    },
    "&$cardHeaderStats$cardHeaderIcon": {
      textAlign: "right",
    },
  },
  cardHeaderPlain: {
    marginLeft: "0px !important",
    marginRight: "0px !important",
  },
  cardHeaderStats: {
    "& $cardHeaderIcon": {
      textAlign: "right",
    },
    "& h1,& h2,& h3,& h4,& h5,& h6": {
      margin: "0 !important",
    },
  },
  cardHeaderIcon: {
    "&$warningCardHeader,&$orangeCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$greenCardHeader,&$cyanCardHeader,&$primaryCardHeader,&$roseCardHeader,&$lightgreenCardHeader,&$brownCardHeader,&$pinkCardHeader,&$neonCardHeader,&$lightorangeCardHeader,&$singlegreenCardHeader,&$multiplegreenCardHeader,&$deviceCardHeader,&$redvoiletCardHeader,&$darkgreenCardHeader,&$licenseCardHeader":
      {
        background: "transparent",
        boxShadow: "none",
      },
    "& i,& .material-icons": {
      width: "33px",
      height: "33px",
      textAlign: "center",
      lineHeight: "33px",
    },
    "& svg": {
      width: "24px",
      height: "24px",
      textAlign: "center",
      lineHeight: "33px",
      margin: "5px 4px 0px",
    },
  },
  warningCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...warningCardHeader,
    },
  },
  orangeCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...orangeCardHeader,
    },
  },
  successCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...successCardHeader,
    },
  },
  dangerCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...dangerCardHeader,
    },
  },
  infoCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...infoCardHeader,
    },
  },
  greenCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...greenCardHeader,
    },
  },
  cyanCardHeader: {
    color: whiteColor,
    "&:not(cardHeaderIcon)": {
      ...cyanCardHeader,
    },
  },
  primaryCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...primaryCardHeader,
    },
  },
  roseCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...roseCardHeader,
    },
  },
  lightgreenCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...lightgreenCardHeader,
    },
  },
  brownCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...brownCardHeader,
    },
  },
  pinkCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...pinkCardHeader,
    },
  },
  neonCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...neonCardHeader,
    },
  },
  lightorangeCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...lightorangeCardHeader,
    },
  },
  singlegreenCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...singlegreenCardHeader,
    },
  },
  darkgreenCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...darkgreenCardHeader,
    },
  },
  lightblueCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...lightblueCardHeader,
    },
  },
  navyblueCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...navyblueCardHeader,
    },
  },
  multiplegreenCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...multiplegreenCardHeader,
    },
  },
  deviceCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...deviceCardHeader,
    },
  },
  redvoiletCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...redvoiletCardHeader,
    },
  },
  licenseCardHeader: {
    color: whiteColor,
    "&:not($cardHeaderIcon)": {
      ...licenseCardHeader,
    },
  },
};

export default cardHeaderStyle;
